import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react-lite';
import { FormikFieldText } from '~/views/atoms/formik.text';
import { Column } from '../../atoms/boxes';
import { t } from 'i18next';
import { FormikFieldAutocomplete } from '~/views/atoms/formik-field-autocomplete';
import { useService } from '~/services/service.base';
import { ServiceThesaurus } from '~/services/service.thesaurus';
export const FormMediaSearchVisitor = observer(() => {
    const formik = useFormikContext();
    const thesaurusService = useService(ServiceThesaurus);
    return (_jsxs(Column, { gap: 2, children: [_jsx(FormikFieldText, { formikProps: formik, name: "fileName", placeholder: t('SEARCH_DIALOG_FILE_NAME') }), _jsx(FormikFieldText, { formikProps: formik, name: "owner", placeholder: t('SEARCH_DIALOG_TITLE') }), _jsx(FormikFieldAutocomplete, { formikProps: formik, name: "depository", placeholder: t('SEARCH_DIALOG_DEPOSITARY'), options: thesaurusService.convertToOptions(thesaurusService.depositories), onChange: (event, value) => {
                    formik.setFieldValue('depository', value);
                } })] }));
});
